<template>
    <el-container direction="vertical">
        <header>
            <header-mobile />
        </header>
        <el-main type="flex">
            <slot>
            </slot>
        </el-main>
    </el-container>
</template>

<script>
import Default from './Default';
import HeaderMobile from './HeaderMobile';
import '@/assets/styles/mobile/main.scss';

export default {
    components: {
        'header-mobile': HeaderMobile
    },
    extends: Default
};
</script>
